module.exports = __webpack_public_path__ + "img/paym.a127b3b2.png";